import AddSubCardConnected from './AddSubCardConnected'

export default AddSubCardConnected
